import * as React from 'react';
import * as _ from 'lodash';
import * as $ from 'jquery';
import * as uuid from 'uuid/v1';

class TypeAheadDD extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid    : uuid(),
            visible : false,
            filter  : '',
        };

        this.mouseListener = this.mouseListener.bind(this);
        this.hide = this.hide.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        $(window).on('click', this.mouseListener);
        $('.dd').on('click', this.mouseListener);
    }

    componentWillUnmount() {
        $(window).off('click', this.mouseListener);
    }

    mouseListener(e) {
        var self = this;

        if (!this.state.visible)
            return;

        if (e.target.className.indexOf(this.state.uuid) !== -1)
            return;

        if (!$(e.target).closest('#'+this.state.uuid).length)
            this.hide();
    }

    hide() {
        var self = this;

        this.setState({ visible : false, filter : '' }, () => {
            $('#'+self.state.uuid).css({'z-index':1});

            if ($('.dd__block').length === 0)
                $('.popup__content').css({'overflow-y':'auto'});
        });
    }

    onChange(e) {
        this.props.onChange(e.target.value);
    }

    onClick(data) {
        var selected = this.props.value || [];

        if (!this.props.multi) {
            this.props.onChange(data.value);
            this.hide();
        } else {

            var isSelected = selected.filter(x => {
                return (data.value === x);
            }).length > 0 ? true : false;

            if (!isSelected) {
                this.props.onChange(selected.concat([data.value]));
            } else {
                var tmp = selected.filter(x => { return x !== data.value; });

                this.props.onChange(tmp.length === 0 ? false : tmp);
            }
        }
    }

    render() {
        const 
            id          = this.props.id,
            multi       = this.props.multi,
            selected    = this.props.selected || false,
            subtitle    = this.props.subtitle,
            refresh     = this.props.onRefresh,
            add         = this.props.onAdd,
            placeholder = this.props.placeholder,
            style       = this.props.style || false,
            disabled    = this.props.disabled,
            hideClear   = this.props.hideClear || false,
            uuid        = this.state.uuid;
        const label = this.props.selected ? selected.label || selected.title : '';

        var footer = refresh || multi;
        return (
            <div
                className='dd input-profile'
                id={this.state.uuid}>

                <input
                    type='text'
                    id={id}
                    data-testid='typehead-dropdown_input_search'
                    className='form-control dd__search'
                    value={label}
                    placeholder={placeholder}
                    onChange={e => { this.onChange(e); }}
                    disabled={disabled}
                    onFocus={() => {
                        if (disabled)
                            return;

                        this.setState({ visible : true }, () => {

                            var left = 0;
                            if ($('#' + uuid).offset().left) {
                                if ($('#' + uuid).offset().left + $('#' + uuid + '__block').width() > $(window).width()) {
                                    left = $('#' + uuid).width() - $('#' + uuid + '__block').width();
                                }
                                if ($('#'+uuid).offset().left + left < 0) {
                                    left = 0;
                                }
                            }

                            $('.dd__filter').focus();
                            $('.dd').trigger('updateContent');
                            $('#'+uuid).css({'z-index':3});
                            $('#'+uuid+'__block').css({'left' : left});
                            $('.popup__content').css({'overflow-y':'visible'});
                        });
                    }} />

                { selected && !hideClear &&
                    <div className='dd__search--clear'>
                        <i
                            className='fa fa-close'
                            onClick={() => { this.props.onChange(null); }} />
                    </div>
                }

                { this.state.visible && 
                    <div
                        className='dd__block'
                        id={uuid+'__block'}
                        style={style.block || {}}>

                        <input
                            type='text'
                            className='dd__filter'
                            value={this.props.filter}
                            placeholder='Search...'
                            onChange={e => { this.props.onFilterChange(e.target.value); }} />


                        <div
                            className={[
                                'dd__content',
                                (footer ? 'dd__content--footer' : ''),
                            ].join(' ')}>

                            { this.props.options.map((x, i) => {
                                var isSelected = false;

                                if (!multi)
                                    isSelected = selected === x.value;
                                else
                                    isSelected = selected && selected.filter(y => {
                                        return x.value === y;
                                    }).length > 0 ? true : false;

                                return (
                                    <div
                                        className={[
                                            'dd__row',
                                            (subtitle ? 'dd__row--high' : ''),
                                            (isSelected ? 'dd__row--selected' : ''),
                                            (multi ? 'dd__row--multi' : ''),
                                        ].join(' ')}
                                        onClick={() => { this.onClick(x); }}
                                        key={uuid+''+x.value+''+i}>

                                        <div>{x.title}</div>
                                        { subtitle &&
                                            <div className={'dd__row--subtitle '+(isSelected ? 'dd__row--selected' : '')}>
                                                {x.subtitle}
                                            </div>
                                        }
                                    </div>
                                );
                            })}

                        </div>

                        { footer &&
                            <div className='dd__footer'>
                                { refresh &&
                                    <span
                                        onClick={() => { this.props.onRefresh(); }}>

                                        Refresh
                                    </span>
                                }

                                { add &&
                                    <span
                                        onClick={() => { add.action(); }}>

                                        {add.title || 'Add'}
                                    </span>
                                }
                            </div>
                        }

                    </div>
                }
            </div>
        );
    }
}

export default TypeAheadDD;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/dropdown/TypeaheadDropdown.react.jsx